/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

// Import Routes

import { Route as rootRoute } from './routes/__root.tsx'

// Create Virtual Routes

const ShareLazyImport = createFileRoute('/share')()
const SettingsLazyImport = createFileRoute('/settings')()
const OrdersLazyImport = createFileRoute('/orders')()
const OrderDetailsLazyImport = createFileRoute('/order-details')()
const MerchantDashboardLazyImport = createFileRoute('/merchant-dashboard')()
const MerchantConnectLazyImport = createFileRoute('/merchant-connect')()
const ListingsLazyImport = createFileRoute('/listings')()
const ListingDetailLazyImport = createFileRoute('/listing-detail')()
const EditListingLazyImport = createFileRoute('/edit-listing')()
const CreateShopLazyImport = createFileRoute('/create-shop')()
const ContactLazyImport = createFileRoute('/contact')()
const CheckoutLazyImport = createFileRoute('/checkout')()
const IndexLazyImport = createFileRoute('/')()

// Create/Update Routes

const ShareLazyRoute = ShareLazyImport.update({
  id: '/share',
  path: '/share',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/share.lazy.tsx').then((d) => d.Route))

const SettingsLazyRoute = SettingsLazyImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/settings.lazy.tsx').then((d) => d.Route))

const OrdersLazyRoute = OrdersLazyImport.update({
  id: '/orders',
  path: '/orders',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/orders.lazy.tsx').then((d) => d.Route))

const OrderDetailsLazyRoute = OrderDetailsLazyImport.update({
  id: '/order-details',
  path: '/order-details',
  getParentRoute: () => rootRoute,
} as any).lazy(() =>
  import('./routes/order-details.lazy.tsx').then((d) => d.Route),
)

const MerchantDashboardLazyRoute = MerchantDashboardLazyImport.update({
  id: '/merchant-dashboard',
  path: '/merchant-dashboard',
  getParentRoute: () => rootRoute,
} as any).lazy(() =>
  import('./routes/merchant-dashboard.lazy.tsx').then((d) => d.Route),
)

const MerchantConnectLazyRoute = MerchantConnectLazyImport.update({
  id: '/merchant-connect',
  path: '/merchant-connect',
  getParentRoute: () => rootRoute,
} as any).lazy(() =>
  import('./routes/merchant-connect.lazy.tsx').then((d) => d.Route),
)

const ListingsLazyRoute = ListingsLazyImport.update({
  id: '/listings',
  path: '/listings',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/listings.lazy.tsx').then((d) => d.Route))

const ListingDetailLazyRoute = ListingDetailLazyImport.update({
  id: '/listing-detail',
  path: '/listing-detail',
  getParentRoute: () => rootRoute,
} as any).lazy(() =>
  import('./routes/listing-detail.lazy.tsx').then((d) => d.Route),
)

const EditListingLazyRoute = EditListingLazyImport.update({
  id: '/edit-listing',
  path: '/edit-listing',
  getParentRoute: () => rootRoute,
} as any).lazy(() =>
  import('./routes/edit-listing.lazy.tsx').then((d) => d.Route),
)

const CreateShopLazyRoute = CreateShopLazyImport.update({
  id: '/create-shop',
  path: '/create-shop',
  getParentRoute: () => rootRoute,
} as any).lazy(() =>
  import('./routes/create-shop.lazy.tsx').then((d) => d.Route),
)

const ContactLazyRoute = ContactLazyImport.update({
  id: '/contact',
  path: '/contact',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/contact.lazy.tsx').then((d) => d.Route))

const CheckoutLazyRoute = CheckoutLazyImport.update({
  id: '/checkout',
  path: '/checkout',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/checkout.lazy.tsx').then((d) => d.Route))

const IndexLazyRoute = IndexLazyImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/index.lazy.tsx').then((d) => d.Route))

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexLazyImport
      parentRoute: typeof rootRoute
    }
    '/checkout': {
      id: '/checkout'
      path: '/checkout'
      fullPath: '/checkout'
      preLoaderRoute: typeof CheckoutLazyImport
      parentRoute: typeof rootRoute
    }
    '/contact': {
      id: '/contact'
      path: '/contact'
      fullPath: '/contact'
      preLoaderRoute: typeof ContactLazyImport
      parentRoute: typeof rootRoute
    }
    '/create-shop': {
      id: '/create-shop'
      path: '/create-shop'
      fullPath: '/create-shop'
      preLoaderRoute: typeof CreateShopLazyImport
      parentRoute: typeof rootRoute
    }
    '/edit-listing': {
      id: '/edit-listing'
      path: '/edit-listing'
      fullPath: '/edit-listing'
      preLoaderRoute: typeof EditListingLazyImport
      parentRoute: typeof rootRoute
    }
    '/listing-detail': {
      id: '/listing-detail'
      path: '/listing-detail'
      fullPath: '/listing-detail'
      preLoaderRoute: typeof ListingDetailLazyImport
      parentRoute: typeof rootRoute
    }
    '/listings': {
      id: '/listings'
      path: '/listings'
      fullPath: '/listings'
      preLoaderRoute: typeof ListingsLazyImport
      parentRoute: typeof rootRoute
    }
    '/merchant-connect': {
      id: '/merchant-connect'
      path: '/merchant-connect'
      fullPath: '/merchant-connect'
      preLoaderRoute: typeof MerchantConnectLazyImport
      parentRoute: typeof rootRoute
    }
    '/merchant-dashboard': {
      id: '/merchant-dashboard'
      path: '/merchant-dashboard'
      fullPath: '/merchant-dashboard'
      preLoaderRoute: typeof MerchantDashboardLazyImport
      parentRoute: typeof rootRoute
    }
    '/order-details': {
      id: '/order-details'
      path: '/order-details'
      fullPath: '/order-details'
      preLoaderRoute: typeof OrderDetailsLazyImport
      parentRoute: typeof rootRoute
    }
    '/orders': {
      id: '/orders'
      path: '/orders'
      fullPath: '/orders'
      preLoaderRoute: typeof OrdersLazyImport
      parentRoute: typeof rootRoute
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsLazyImport
      parentRoute: typeof rootRoute
    }
    '/share': {
      id: '/share'
      path: '/share'
      fullPath: '/share'
      preLoaderRoute: typeof ShareLazyImport
      parentRoute: typeof rootRoute
    }
  }
}

// Create and export the route tree

export interface FileRoutesByFullPath {
  '/': typeof IndexLazyRoute
  '/checkout': typeof CheckoutLazyRoute
  '/contact': typeof ContactLazyRoute
  '/create-shop': typeof CreateShopLazyRoute
  '/edit-listing': typeof EditListingLazyRoute
  '/listing-detail': typeof ListingDetailLazyRoute
  '/listings': typeof ListingsLazyRoute
  '/merchant-connect': typeof MerchantConnectLazyRoute
  '/merchant-dashboard': typeof MerchantDashboardLazyRoute
  '/order-details': typeof OrderDetailsLazyRoute
  '/orders': typeof OrdersLazyRoute
  '/settings': typeof SettingsLazyRoute
  '/share': typeof ShareLazyRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexLazyRoute
  '/checkout': typeof CheckoutLazyRoute
  '/contact': typeof ContactLazyRoute
  '/create-shop': typeof CreateShopLazyRoute
  '/edit-listing': typeof EditListingLazyRoute
  '/listing-detail': typeof ListingDetailLazyRoute
  '/listings': typeof ListingsLazyRoute
  '/merchant-connect': typeof MerchantConnectLazyRoute
  '/merchant-dashboard': typeof MerchantDashboardLazyRoute
  '/order-details': typeof OrderDetailsLazyRoute
  '/orders': typeof OrdersLazyRoute
  '/settings': typeof SettingsLazyRoute
  '/share': typeof ShareLazyRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexLazyRoute
  '/checkout': typeof CheckoutLazyRoute
  '/contact': typeof ContactLazyRoute
  '/create-shop': typeof CreateShopLazyRoute
  '/edit-listing': typeof EditListingLazyRoute
  '/listing-detail': typeof ListingDetailLazyRoute
  '/listings': typeof ListingsLazyRoute
  '/merchant-connect': typeof MerchantConnectLazyRoute
  '/merchant-dashboard': typeof MerchantDashboardLazyRoute
  '/order-details': typeof OrderDetailsLazyRoute
  '/orders': typeof OrdersLazyRoute
  '/settings': typeof SettingsLazyRoute
  '/share': typeof ShareLazyRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/checkout'
    | '/contact'
    | '/create-shop'
    | '/edit-listing'
    | '/listing-detail'
    | '/listings'
    | '/merchant-connect'
    | '/merchant-dashboard'
    | '/order-details'
    | '/orders'
    | '/settings'
    | '/share'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/checkout'
    | '/contact'
    | '/create-shop'
    | '/edit-listing'
    | '/listing-detail'
    | '/listings'
    | '/merchant-connect'
    | '/merchant-dashboard'
    | '/order-details'
    | '/orders'
    | '/settings'
    | '/share'
  id:
    | '__root__'
    | '/'
    | '/checkout'
    | '/contact'
    | '/create-shop'
    | '/edit-listing'
    | '/listing-detail'
    | '/listings'
    | '/merchant-connect'
    | '/merchant-dashboard'
    | '/order-details'
    | '/orders'
    | '/settings'
    | '/share'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexLazyRoute: typeof IndexLazyRoute
  CheckoutLazyRoute: typeof CheckoutLazyRoute
  ContactLazyRoute: typeof ContactLazyRoute
  CreateShopLazyRoute: typeof CreateShopLazyRoute
  EditListingLazyRoute: typeof EditListingLazyRoute
  ListingDetailLazyRoute: typeof ListingDetailLazyRoute
  ListingsLazyRoute: typeof ListingsLazyRoute
  MerchantConnectLazyRoute: typeof MerchantConnectLazyRoute
  MerchantDashboardLazyRoute: typeof MerchantDashboardLazyRoute
  OrderDetailsLazyRoute: typeof OrderDetailsLazyRoute
  OrdersLazyRoute: typeof OrdersLazyRoute
  SettingsLazyRoute: typeof SettingsLazyRoute
  ShareLazyRoute: typeof ShareLazyRoute
}

const rootRouteChildren: RootRouteChildren = {
  IndexLazyRoute: IndexLazyRoute,
  CheckoutLazyRoute: CheckoutLazyRoute,
  ContactLazyRoute: ContactLazyRoute,
  CreateShopLazyRoute: CreateShopLazyRoute,
  EditListingLazyRoute: EditListingLazyRoute,
  ListingDetailLazyRoute: ListingDetailLazyRoute,
  ListingsLazyRoute: ListingsLazyRoute,
  MerchantConnectLazyRoute: MerchantConnectLazyRoute,
  MerchantDashboardLazyRoute: MerchantDashboardLazyRoute,
  OrderDetailsLazyRoute: OrderDetailsLazyRoute,
  OrdersLazyRoute: OrdersLazyRoute,
  SettingsLazyRoute: SettingsLazyRoute,
  ShareLazyRoute: ShareLazyRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/checkout",
        "/contact",
        "/create-shop",
        "/edit-listing",
        "/listing-detail",
        "/listings",
        "/merchant-connect",
        "/merchant-dashboard",
        "/order-details",
        "/orders",
        "/settings",
        "/share"
      ]
    },
    "/": {
      "filePath": "index.lazy.tsx"
    },
    "/checkout": {
      "filePath": "checkout.lazy.tsx"
    },
    "/contact": {
      "filePath": "contact.lazy.tsx"
    },
    "/create-shop": {
      "filePath": "create-shop.lazy.tsx"
    },
    "/edit-listing": {
      "filePath": "edit-listing.lazy.tsx"
    },
    "/listing-detail": {
      "filePath": "listing-detail.lazy.tsx"
    },
    "/listings": {
      "filePath": "listings.lazy.tsx"
    },
    "/merchant-connect": {
      "filePath": "merchant-connect.lazy.tsx"
    },
    "/merchant-dashboard": {
      "filePath": "merchant-dashboard.lazy.tsx"
    },
    "/order-details": {
      "filePath": "order-details.lazy.tsx"
    },
    "/orders": {
      "filePath": "orders.lazy.tsx"
    },
    "/settings": {
      "filePath": "settings.lazy.tsx"
    },
    "/share": {
      "filePath": "share.lazy.tsx"
    }
  }
}
ROUTE_MANIFEST_END */
